
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/funeral-prepare/company-introduction",
      function () {
        return require("private-next-pages/funeral-prepare/company-introduction.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/funeral-prepare/company-introduction"])
      });
    }
  